import { TicketServiceType as r } from "../../../../../common/shared/ticketServiceType.js";
import { TicketStatus as e } from "./ticket.types.js";
function c(t) {
  switch (t) {
    case e.COMPLETED:
      return "order.status.completed";
    case e.CONFIRMED:
      return "order.status.confirmed";
    case e.READY:
      return "order.status.ready";
    case e.ON_ROUTE:
      return "order.status.onroute";
    case e.CANCELLED:
      return "order.status.cancelled";
    case e.REQUESTED:
      return "order.status.unconfirmed";
    default:
      return "unknown";
  }
}
function s(t) {
  switch (t) {
    case r.DINEIN:
      return "dinein";
    case r.TAKEAWAY:
      return "takeaway";
    case r.BOOKING:
      return "booking";
    case r.DELIVERY:
      return "delivery";
    default:
      throw new Error("Unreachable");
  }
}
export {
  s as getTicketServiceTypeStr,
  c as getTicketStatusKey
};
//# sourceMappingURL=utils.js.map
